module.exports = __webpack_public_path__ + "media/src/images/step03-64584065432deec3baa6237bf79b7184.png";